if (!customElements.get("m-products-banner-slider")) {
  class MProductsBannerSlider extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
    }

    connectedCallback() {
      this.slideContainer = this.querySelector(".swiper-container");
      this.slideInner = this.querySelector(".swiper-wrapper");
      this.enableSlider = this.dataset.enableSlider === "true";
      this.items = parseInt(this.dataset.items) || 4;
      this.itemsMobile = parseInt(this.dataset.itemsMobile) || 2;
      this.itemGap = parseInt(this.dataset.gutter) || 24;
      this.itemGapMobile = parseInt(this.dataset.gutterMobile) || 16;
      this.autoplay = this.dataset.autoplay === "true";
      this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed) || 5;

      this.init();

      document.addEventListener("matchMobile", () => this.init());
      document.addEventListener("unmatchMobile", () => this.init());
    }

    init() {
      if (!this.enableSlider || !this.slideContainer) return;
      this.initSlider();
    }

    initSlider() {
      if (typeof MinimogLibs === "undefined" || !MinimogLibs.Swiper) return;

      const prevButton = this.querySelector(".m-slider-controls__button-prev");
      const nextButton = this.querySelector(".m-slider-controls__button-next");

      this.options = {
        slidesPerView: this.itemsMobile === 1 ? 1.25 : 2.2,
        spaceBetween: this.itemGapMobile,
        loop: false,
        slidesPerGroup: 1,
        navigation: (nextButton || prevButton) ? {
          nextEl: nextButton,
          prevEl: prevButton
        } : false,
        autoplay: this.autoplay ? {
          delay: this.autoplaySpeed * 1000,
          disableOnInteraction: false
        } : false,
        breakpoints: {
          480: {
            slidesPerView: this.itemsMobile === 1 ? 1.4 : 2.3,
            spaceBetween: this.itemGapMobile,
          },
          768: {
            slidesPerView: Math.min(3, this.items),
            spaceBetween: this.itemGap,
          },
          1024: {
            slidesPerView: Math.min(4, this.items),
            spaceBetween: this.itemGap,
          },
          1280: {
            slidesPerView: this.items,
            spaceBetween: this.itemGap,
          }
        }
      };

      if (!this.slider) {
        this.slider = new MinimogLibs.Swiper(this.slideContainer, this.options);

        const updateProgressBar = () => {
          const progressFills = this.querySelectorAll(".m-slider-progress-fill");
          if (!progressFills.length || !this.slider) return;

          const snapCount = this.slider.snapGrid ? this.slider.snapGrid.length : 0;
          const totalSlides = this.slider.slides ? this.slider.slides.length : 1;
          const slidesPerView = (this.slider.params && typeof this.slider.params.slidesPerView === "number")
            ? this.slider.params.slidesPerView
            : 1;
          const totalSteps = snapCount > 0 ? snapCount : Math.max(1, totalSlides - slidesPerView + 1);

          if (totalSteps <= 1) {
            progressFills.forEach((fill) => {
              fill.style.width = "100%";
            });
            return;
          }

          const minPercent = (1 / totalSteps) * 100;
          let percentage = minPercent;

          if (this.slider.isEnd) {
            percentage = 100;
          } else if (this.slider.isBeginning) {
            percentage = minPercent;
          } else if (typeof this.slider.progress === "number" && !isNaN(this.slider.progress)) {
            percentage = minPercent + Math.max(0, Math.min(1, this.slider.progress)) * (100 - minPercent);
          } else {
            const currentStep = (this.slider.snapIndex !== undefined ? this.slider.snapIndex : this.slider.activeIndex || 0) + 1;
            percentage = (currentStep / totalSteps) * 100;
          }

          percentage = Math.min(100, Math.max(minPercent, percentage));
          progressFills.forEach((fill) => {
            fill.style.width = `${percentage}%`;
          });
        };

        this.slider.on("slideChange", updateProgressBar);
        this.slider.on("setTranslate", updateProgressBar);
        this.slider.on("transitionEnd", updateProgressBar);
        this.slider.on("init", updateProgressBar);

        // Run once after swiper mounts
        requestAnimationFrame(() => updateProgressBar());
      }
    }

    disconnectedCallback() {
      if (this.slider && typeof this.slider.destroy === "function") {
        this.slider.destroy();
        this.slider = null;
      }
    }
  }

  customElements.define("m-products-banner-slider", MProductsBannerSlider);
}
